import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact-list',
    templateUrl: './contact-list.component.html',
    styleUrls: ['./contact-list.component.scss'],
    standalone: false
})
export class ContactListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
